import { createFileRoute } from '@tanstack/react-router'

import { CampaignsListPage } from '@/features/campaigns'

export const Route = createFileRoute('/_authenticated/_main/campanhas/')({
  component: CampaignsListPage
})
